/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_ElectricalInputs */

const en_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electrical`)
};

const es_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Electricidad`)
};

const fr_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Électricité`)
};

const de_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elektro`)
};

const ja_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`電気工事`)
};

const zh_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`电气服务`)
};

const ar_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كهرباء`)
};

const id_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kelistrikan`)
};

const it_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elettricità`)
};

const ru_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Электрика`)
};

const pt_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elétrica`)
};

const ko_val_electrical = /** @type {(inputs: Val_ElectricalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`전기`)
};

/**
* | output |
* | --- |
* | "Electrical" |
*
* @param {Val_ElectricalInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_electrical = /** @type {((inputs?: Val_ElectricalInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_ElectricalInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_electrical(inputs)
	if (locale === "es") return es_val_electrical(inputs)
	if (locale === "fr") return fr_val_electrical(inputs)
	if (locale === "de") return de_val_electrical(inputs)
	if (locale === "ja") return ja_val_electrical(inputs)
	if (locale === "zh") return zh_val_electrical(inputs)
	if (locale === "ar") return ar_val_electrical(inputs)
	if (locale === "id") return id_val_electrical(inputs)
	if (locale === "it") return it_val_electrical(inputs)
	if (locale === "ru") return ru_val_electrical(inputs)
	if (locale === "pt") return pt_val_electrical(inputs)
	return ko_val_electrical(inputs)
});